import styled from '@emotion/styled';

export const Contenedor = styled.div`
  max-width: 600px;
  margin: 0 auto;
`;

export const ContenedorFormulario = styled.div`
  background-color: #fff;
  padding: 3rem;
`;

export const ContenedorDescripcion = styled.h5`
  text-align: center;
  color: white;
`;
